import Alpine from 'alpinejs'
export const isStickyHeader = () => {
  let isSticky = window.scrollY < 100 || window.oldScroll > window.scrollY
  window.oldScroll = window.scrollY

  Alpine.store('Header').setScrollPosition(window.scrollY)

  if (isSticky) {
    Alpine.store('Header').show()
  } else {
    Alpine.store('Header').hide()
  }
}

window.isStickyHeader = isStickyHeader
